module.exports = __webpack_public_path__ + "static/media/271590_screenshots_20170331230557_1.77a4d3bd.jpg";